import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  return (
    <div className="navbar">
      <ul>
        <li>
          <Link to="/HomePage">HomePage</Link>
        </li>
        <li>
          <Link to="/get">GetPost</Link>
        </li>
        <li>
          <Link to="/create">SendPost</Link>
        </li>
        <li>
          <Link to="/update">ModifyPost</Link>
        </li>
        <li>
          <Link to="/delete">DeletePost</Link>
        </li>
        <li>
          <Link to="/search">SearchPost</Link>
        </li>
      </ul>
    </div>
  );
}

export default Navbar;
